import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";

const GroupedItemsAccordion = ({ groupedItems }) => {
  // Check if groupedItems is available and not empty
  const hasGroupedItems =
    groupedItems &&
    typeof groupedItems === "object" &&
    Object.keys(groupedItems).length > 0;

  if (!hasGroupedItems) {
    return (
      <Typography sx={{ textAlign: "center", padding: "20px" }}>
        No invoice items available
      </Typography>
    );
  }

  return (
    <>
      {Object.keys(groupedItems).map((category) => (
        <Accordion key={category}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{ backgroundColor: "#f5f5f5" }}
            aria-controls={`panel-${category}-content`}
            id={`panel-${category}-header`}
          >
            <Typography component="span">{category}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#f5f5f5" }}>
            {groupedItems[category].length > 0 ? (
              <Table>
                <TableHead
                  sx={{
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <TableRow>
                    <TableCell>Item Name</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groupedItems[category].map((item) => (
                    <TableRow key={item._id}>
                      <TableCell>{item.item?.itemName || "-"}</TableCell>
                      <TableCell>{item.quantity || "-"}</TableCell>
                      <TableCell>₹{item.finalAmount || "-"}</TableCell>
                      <TableCell>
                        {item.createdAt
                          ? dayjs(item.createdAt).format("YYYY-MM-DD")
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Typography sx={{ textAlign: "center", padding: "20px" }}>
                No items in this category
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default GroupedItemsAccordion;
